import { render, staticRenderFns } from "./FeesCom.vue?vue&type=template&id=efd44914&scoped=true"
import script from "./FeesCom.vue?vue&type=script&lang=js"
export * from "./FeesCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd44914",
  null
  
)

export default component.exports